import { getServiceName } from '@repo/utils';

import BubblechatYouthProtectionPolicy from './bubblechat'; // bubblechat 전용
import TingleYouthProtectionPolicy from './tingle'; // tingle 전용

const YouthProtectionPolicy = () => {
  const serviceName = getServiceName();
  if (serviceName === 'tingle') return <TingleYouthProtectionPolicy />;
  return <BubblechatYouthProtectionPolicy />;
};

export default YouthProtectionPolicy;
